<template>
  <div class="container">
    <div class="order box">
      <div class="title">
        <span>拜访人信息</span>
      </div>
      <div class="info-box">
        <div class="row">
          <span>状态：</span>
          <span>{{info.status | status}}</span>
        </div>
        <div class="row">
          <span>类型：</span>
          <span>{{info.type | type}}</span>
        </div>
        <!-- <div class="row">
          <span>订单编号：</span>
          <span>{{info.orderNum }}</span>
        </div> -->
        <div class="row">
          <span>拜访人：</span>
          <span>{{info.name}}</span>
        </div>
        <div class="row">
          <span>手机号码：</span>
          <span>{{info.mobile}}</span>
        </div>
      </div>
    </div>
    <div class="visit box">
      <div class="title">
        <span>受访人信息</span>
      </div>
      <div class="info-box">
        <div class="row">
          <div class="item">
            <div class="name">受访人：</div>
            <div>{{info.visitName}}</div>
          </div>
          <div class="item">
            <div class="name">受访人电话：</div>
            <div>{{info.visitMobile}}</div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="name">拜访时间：</div>
            <div>{{info.reservationDate}}</div>
          </div>

          <div class="item">
            <div class="name">所属产业：</div>
            <div>{{info.industryName}}</div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="name">拜访企业：</div>
            <div>{{info.enterpriseName}}</div>
          </div>
        </div>
        <div class="row" v-if="info.status === 4">
          <div class="item">
            <div class="name">拒绝原因: </div>
            <el-input
              type="textarea"
              show-word-limit
              placeholder="请填写拒绝原因"
              v-model="info.refusalReason"
              maxlength="9999"
              :autosize="{ minRows: 10, maxRows: 20 }"/>
          </div>
        </div>
      </div>
    </div>
    <div class="return">
      <el-button @click="returnBack" type="primary">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getPassInfo } from '@/api/user'
export default {
  data() {
    return {
      info: ''
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) {
        return '未完成'
      } else if (val === 1) {
        return '已完成'
      } else if(val === 2){
        return '已取消'
      } else if(val === 3){
        return '待审核'
      } else if(val === 4){
        return '已拒绝'
      }
    },
    type: function(val) {
      if (val === 0) {
        return '临时访客'
      } else return '企业访客'
    }
  },
  mounted() {
    this.network().getPassInfo()
  },
  methods: {
    event() {

    },
    network() {
      return {
        getPassInfo: async() => {
          const { data } = await getPassInfo(this.$route.query.uuid)
          this.info = data
        }
      }
    },
    returnBack(){
      this.$router.go(-1)
    }
  },
  beforeRouteLeave(to, form, next){
    if (!to.path.includes('/user-management/user-details/get')) {
      this.$store.dispatch('global/deleteRoute', 'DetailsManagement')
    }
    next()
  },
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  background-color: transparent;
  .box{
    margin-bottom: 15px;
    background: #ffffff;
    padding: 15px 30px;
    border-radius: 5px;
    .title{
      font-weight: bold;
      margin-bottom: 30px;
    }
    .info-box{
      width: 1000px;
    }
    .row{
      margin-bottom: 30px;
      display: flex;
      .item{
        display: flex;
        flex: 1;
        .name{
          color: grey;
          width: 120px;
        }
      }
      span{
        color: grey;
        &:nth-child(1){
          flex: 1;
        }
        &:nth-child(2){
          flex: 9;
        }
      }
    }
  }
  .return{
    display: flex;
    margin-bottom: 30px;
    justify-content: center;
  }
}
</style>
